import {format} from "date-fns";

const formatDate = (date) => {
  return format(new Date(date), 'dd/MM/yyyy')
}
const formatDateTime = (date) => {
  return format(new Date(date), 'dd/MM/yyyy H:mm')
}

const price = (value, decimal) => {
  if (decimal === undefined){
    decimal = 2;
  }
  return Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: decimal,
  }).format(value);
}

export {
  price,
  formatDate,
  formatDateTime
}